import { Box, Pressable } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken, spacing } from 'styles/constants';

export const Tile = Box.withConfig(() => ({
  background: getDesignToken('background-pattern'),
  shadow: '1',
  borderRadius: '2xl',
  alignItems: 'center',
  minHeight: '$48',
  paddingX: '$4',
  paddingTop: '$1',
  paddingBottom: '$4',
  marginY: '$4',
  justifyContent: {
    md: 'space-between',
  },
  flexDirection: {
    md: 'row',
  },
}));

export const Col = Box.withConfig(() => ({
  width: {
    md: '48%',
    base: 'full',
  },
  marginBottom: {
    md: '$0',
  },
}));

export const MoreItems = Pressable.withConfig({
  paddingTop: spacing.$0_5,
  background: 'transparent',
});

export const MoreItemsText = withTypography({
  color: getDesignToken('text-accent-order-number'),
  fontSize: 'sm',
});

export const FormattedDate = withTypography({
  mb: '$6',
  style: { textTransform: getDesignToken('text-transform-headlines') },
});

export const SubtitleContainer = withTypography({ color: getDesignToken('text-default') });

export const NumItems = withTypography({ ml: '$1' });

export const Items = Box.withConfig(() => ({
  lineHeight: '16',
  paddingRight: '$4',
  margin: '$0',
}));

export const ItemNameContainer = Box.withConfig(() => ({
  alignItems: 'flex-start',
  marginBottom: '$6',
  color: getDesignToken('text-default'),
}));

export const Wrap = Box.withConfig(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  height: {
    md: 'auto',
  },
}));

export const OrderNumberWrapper = Box.withConfig(() => ({
  flexDirection: 'row',
  marginX: '$0',
  marginTop: '$4',
}));

export const OrderNumberText = withTypography({ fontSize: 'sm', style: { fontWeight: '400' } });

export const OrderNumber = withTypography({
  color: getDesignToken('text-accent-order-number'),
  fontSize: 'md',
  m: '$0',
  pl: '$1',
});

export const OrderBox = Box.withConfig(() => ({
  marginTop: '$4',
  width: 'full',
}));

export const OrdersEmptyWrapper = Box.withConfig({
  minHeight: '2/3',
  paddingTop: '1/6',
  justifyContent: 'center',
});

export const OfferDisclaimer = withTypography({ textAlign: 'center', mt: '$3', px: '$4' });
